/**
 * Shared helpers for the familias admin module.
 */

export function estadoBadgeClass(estado) {
    const map = {
        pendiente: 'tw:bg-yellow-100 tw:text-yellow-800',
        aprobado: 'tw:bg-green-100 tw:text-green-800',
        rechazado: 'tw:bg-red-100 tw:text-red-800',
    }
    return map[estado] || 'tw:bg-gray-100 tw:text-gray-600'
}

export function estadoLabel(estado) {
    const map = {
        pendiente: 'Pendiente',
        aprobado: 'Aprobado',
        rechazado: 'Rechazado',
    }
    return map[estado] || estado
}

export function renovacionBadgeClass(estado) {
    const map = {
        renovado: 'tw:bg-green-100 tw:text-green-800',
        activo: 'tw:bg-green-100 tw:text-green-800',
        pendiente: 'tw:bg-yellow-100 tw:text-yellow-800',
        inactivo: 'tw:bg-gray-100 tw:text-gray-600',
    }
    return map[estado] || 'tw:bg-gray-100 tw:text-gray-600'
}

export function renovacionLabel(estado) {
    const map = {
        renovado: 'Renovado',
        activo: 'Activo',
        pendiente: 'Pendiente',
        inactivo: 'Inactivo',
    }
    return map[estado] || estado || '—'
}
